import http from "infra/http";
import { useMutation } from "react-query";
import { ConfiguracaoWhiteLabelForm } from "../typings";

function useSaveConfiguracaoWhiteLabel(tenantId: string) {
  return useMutation(
    [`/v1/configuracao-whitelabel`],
    async (form: ConfiguracaoWhiteLabelForm) => {
      return http.post(`/v1/configuracao-whitelabel`, form, {
        headers: {
          tenant: tenantId,
        },
      });
    }
  );
}

export default useSaveConfiguracaoWhiteLabel;
